// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37sl1","left":"styles_left__1UD00"};